/* eslint-disable @typescript-eslint/no-explicit-any */
import { FaSearch } from 'react-icons/fa';

import React, { useEffect, useRef, useState } from 'react';

import axios from 'axios';
import { useTypedSelector } from '../../hooks/useTypeSelector';
import { globalEnv } from '../../config/baseConfig';
import LazyImage from '../Utils/Components/imageComponent';

export function AddTopicModal({
	buttonRef,
	setTopic,
	isModalOpen,
	setIsModalOpen,
	setIsChanged,
	searchTerm,
	setSearchTerm
}: {
	buttonRef: any;
	setTopic: (topic: any) => void;
	isModalOpen: boolean;
	setIsModalOpen: (ismodalOpen: boolean) => void;
	setIsChanged: (ismodalOpen: boolean) => void;
	searchTerm: string;
	setSearchTerm: (searchTerm: string) => void;
}) {
	const [topicsList, setTopicsList] = useState([]);
	const [page, setPage] = useState(1);
	const [isShown, setIsShown] = useState(false);
	const [noTopicsFound, setNoTopicsFound] = useState(false);

	const [searchResultsRef, setSearchResultsRef] = useState(useRef());
	const inputRef: any = useRef(null);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			setNoTopicsFound(false);
			fetchEditorsList(searchTerm);
		}, 600);

		return () => clearTimeout(delayDebounceFn);
	}, [searchTerm]);

	async function fetchEditorsList(searchTerm: string) {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		try {
			const { data } = await axios.get(
				`${globalEnv.BASE_URL}/topic/get-all?filter=${searchTerm}&page=${page}`,
				config
			);
			if (data.meta.pages < page) {
				setPage(1);
			}
			setTopicsList(data.topics);
		} catch (e) {
			setTopicsList([]);
			setNoTopicsFound(true);
		}
	}

	useDetectClickOut(
		isShown,
		isModalOpen,
		setIsModalOpen,
		buttonRef,
		inputRef,
		searchResultsRef
	);

	return (
		<div className="" ref={inputRef}>
			<div>
				<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-1">
					Selected Topic
				</label>
				<input
					className="inputStyle2"
					id="grid-last-name"
					type="text"
					placeholder="Topic Name"
					onFocus={() => setIsShown(true)}
					autoFocus
					onChange={(e) => {
						setSearchTerm(e.target.value);
					}}
					value={searchTerm}
				/>
			</div>
			{isShown &&
				(noTopicsFound ? (
					<div className="absolute z-50 top-18 bg-gray-300 dark:bg-gray-700 mt-2 w-full h-fit flex flex-col items-start rounded-lg overflow-hidden  ">
						<a className="w-full h-14 flex items-start" target="_blank">
							<p className="ml-2 hover:bg-gray-400 align-middle self-center dark:text-gray-200">
								No topics found{' '}
							</p>
						</a>
					</div>
				) : (
					<EditorElem
						topicsList={topicsList}
						setMyRef={setSearchResultsRef}
						setTopic={setTopic}
						setIsChanged={setIsChanged}
						setIsmodalOpen={setIsModalOpen}
					/>
				))}
		</div>
	);
}

export function EditorElem({
	topicsList,
	setMyRef,
	setTopic,
	setIsChanged,
	setIsmodalOpen
}: {
	topicsList: any[];
	setMyRef: (ref: any) => void;
	setTopic: (contibutors: any[]) => void;
	setIsChanged: (ismodalOpen: boolean) => void;
	setIsmodalOpen: (isShown: boolean) => void;
}) {
	const nodeRef: any = useRef(null); // optional
	useEffect(() => {
		setMyRef(nodeRef);
	}, [nodeRef]);

	const setTopicAsSelected = (topic: any) => {
		setTopic(topic);
		setIsChanged(true);
		setIsmodalOpen(false);
	};

	return (
		<div
			ref={nodeRef}
			className="absolute z-50 top-18 bg-gray-300 dark:bg-gray-700 mt-2 w-full h-fit flex flex-col items-start rounded-lg overflow-hidden "
		>
			{topicsList.slice(0, 15).map((topic: any, key) => {
				return (
					<div
						className="w-full h-full flex items-start align-middle px-4 py-3 dark:hover:bg-gray-600 hover:bg-gray-400 cursor-pointer"
						onClick={() => setTopicAsSelected(topic)}
					>
						<div className="mr-2">
							<LazyImage
								photo={
									topic.backgroundImage != null
										? topic.backgroundImage.url_low_res
										: `https://api.dicebear.com/7.x/bottts/svg?seed=${topic.name}`
								}
								dimesnions={'25'}
								loaderDimesnions={23}
							/>
						</div>
						<div className="font-medium text-sm mt-0.5 text-gray-800 dark:text-white group-hover:text-white dark:group-hover:text-gray-800">
							{topic.name}
						</div>
					</div>
				);
			})}
		</div>
	);
}

export function useDetectClickOut(
	isShown: boolean,
	ismodalOpen: boolean,
	setIsmodalOpen: (show: boolean) => void,
	buttonRef: any,
	triggerRef: any,
	nodeRef: any
) {
	const handleClickOutside = (event: any) => {
		if (
			triggerRef.current &&
			!triggerRef.current.contains(event.target) &&
			buttonRef.current &&
			!buttonRef.current.contains(event.target)
		) {
			if (isShown) {
				if (nodeRef.current && !nodeRef.current.contains(event.target))
					return setIsmodalOpen(!ismodalOpen);
			}
			return setIsmodalOpen(!ismodalOpen);
		}
	};
	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	});
	return {
		triggerRef,
		nodeRef
	};
}
